import amplitude from 'tools/amplitude/amplitude';

import type { LogPrintedOrderParams } from './analytic.model';

function logPrintedOrder(eventParams: LogPrintedOrderParams) {
  amplitude.logEvent('PRINTED_ORDER', {
    ORDER_ID: eventParams.orderId,
    PARTNER_ID: eventParams.partnerId,
    STORE_ID: eventParams.storeId,
    CREATED_TIME: eventParams.orderCreatedAt,
    PRINTED_ENABLED: eventParams.printedEnabled,
    QR_CODE: eventParams.hasQRCode.toString(),
  });
}

export const orderToPrintAnalytic = {
  logPrintedOrder,
};
